import { useEffect } from 'react';

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const SEO = ({
  title = 'RecruiterIQ - AI-Powered Recruitment Intelligence Platform',
  description = 'Transform your recruitment with AI-powered market intelligence, smart sourcing, candidate scoring, and TA certifications. Join 10,000+ talent acquisition professionals.',
  canonical,
  ogImage = 'https://therecruiteriq.com/images/triq-logo.png',
  keywords = 'recruitment intelligence, AI recruiting, talent acquisition, candidate sourcing, recruitment analytics, TA certification',
  schema
}) => {
  const schemaJson = schema ? JSON.stringify(schema) : null;

  useEffect(() => {
    const siteUrl = 'https://therecruiteriq.com';
    const canonicalUrl = canonical || siteUrl;

    document.title = title;
    upsertMeta('name', 'title', title);
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('name', 'robots', 'index, follow');
    upsertMeta('name', 'author', 'RecruiterIQ');

    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:site_name', 'RecruiterIQ');

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:url', canonicalUrl);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    let script = document.getElementById('seo-jsonld');
    if (schemaJson) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'seo-jsonld';
        document.head.appendChild(script);
      }
      script.textContent = schemaJson;
    } else if (script) {
      script.remove();
    }
  }, [title, description, canonical, ogImage, keywords, schemaJson]);

  return null;
};

export default SEO;
